import { createGlobalStyle } from 'styled-components';
import { down } from 'styled-breakpoints';

export default createGlobalStyle`
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #d3d3d3;
    overflow-x: hidden;

    ${down('sm')} {
      background-color: #ffffff;
    }
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }

  .MuiDataGrid-root {
    .MuiDataGrid-columnHeaderTitleContainer {
      padding: 0;
    }

    .MuiDataGrid-columnHeader:not(:hover):not(.MuiDataGrid-columnHeader--sorted) {
      .MuiDataGrid-columnHeaderDraggableContainer {
        display: block;
        position: relative;

        .MuiDataGrid-menuIcon {
          position: absolute;
        }
      }

      .MuiDataGrid-columnHeaderTitleContainer {
        display: block;
        position: relative;

        .MuiDataGrid-iconButtonContainer {
          position: absolute;
        }
      }
    }
  }
`;
